import PlayerData from "../PlayerData";
import { GameState } from "./GameState";
import { Player } from "./Player";
import { RecapPopup } from "./RecapPopup";

export class GameOverState extends GameState {

	start(): void {
		PlayerData.Instance.save();
		this.game.player.once(Player.ON_FINISHED_FAIL_ANIM, (): void => {
			const recap = new RecapPopup(this.scene, this.game.getPlayerDistance(), this.game.coins);
			this.scene.uiContainer.add(recap);
			this.scene.addResize(() => {
				this.scene.alignIn.Center(recap, this.scene.viewport);
			});
		});
	}

}